var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 35,
    viewBox: "0 0 47 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#3373EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9391 17.5L29.484 17.5M29.484 17.5L24.2115 10.7916M29.484 17.5L24.2115 24.2083",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewArrow);
export default __webpack_public_path__ + "static/media/view-arrow.bf34faaeb59c539ebc40ab0515dda53c.svg";
export { ForwardRef as ReactComponent };